/** @jsx jsx **/
import { jsx, Flex } from 'theme-ui'

interface Props {
  handleClickResetFilters: () => void
}

const FilterReset = ({ handleClickResetFilters }: Props) => {
  return (
    <Flex
      sx={{
        justifyContent: ['center', null, 'flex-end'],
      }}
    >
      <button
        sx={{
          color: '#808080',
          backgroundColor: 'transparent',
          border: 'none',
          fontSize: '13px',
          cursor: 'pointer',
          letterSpacing: '0.5px',
        }}
        onClick={handleClickResetFilters}
      >
        RESET
      </button>
    </Flex>
  )
}

export default FilterReset
